// extracted by mini-css-extract-plugin
export default {"title":"Error404_title__StNJR","paragraph":"Error404_paragraph__YENzO","content":"Error404_content__vm3qM"};